<app-coming-soon title="Queue" icon="queue"></app-coming-soon>
